import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { WorkflowStepsComponent } from './workflow-steps.component';
import { EditWorkflowStepDescriptionComponent } from './dialogs/edit-description/edit-description.component';

@NgModule({
  declarations: [
    WorkflowStepsComponent,
    EditWorkflowStepDescriptionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
  ],
  exports: [
    WorkflowStepsComponent,
    EditWorkflowStepDescriptionComponent
  ]
})
export class WorkflowStepsModule { }
